import { get } from '../index';

export const getRevision = (company) => {
  return get(`/revision/?company=${company}`);
};
